import {useCipHttpsCallable} from '../use_cip_https_callable';
import {
  QueueNewUserNudgeTaskRequest,
  QueueNewUserNudgeTaskResponse,
} from './newUserNudgeTaskApi';

export const useQueueNewUserNudge = () => {
  return useCipHttpsCallable<
    QueueNewUserNudgeTaskRequest,
    QueueNewUserNudgeTaskResponse
  >('queuenewusernudge');
};
